import { memo, type FC, type ReactNode } from 'react';

import { Loader } from '../../Elements/Loader/index.tsx';
import { Section } from '../Section/index.tsx';
import { InfoBlock, InfoDate, InfoLabel, InfoName } from './styled.ts';

export interface InformationCardItem {
  label: string;
  title?: ReactNode;
  date?: string;
  dataTestId?: string;
}

interface InformationCardProps {
  items: InformationCardItem[];
  isLoading?: boolean;
}

export const InformationCard: FC<InformationCardProps> = memo(function InformationCard({ items, isLoading }) {
  return (
    <Section>
      {isLoading ? (
        <InfoBlock>
          <Loader size='18px' content />
        </InfoBlock>
      ) : (
        <>
          {items.map((item) => (
            <InfoBlock key={item.label} data-testid={item.dataTestId}>
              <InfoLabel>{item.label}</InfoLabel>
              {item.title && <InfoName>{item.title}</InfoName>}
              {item.date && <InfoDate>{item.date}</InfoDate>}
            </InfoBlock>
          ))}
        </>
      )}
    </Section>
  );
});
